import React from 'react';
import {
  FDBox,
  FDDeleteButton, FDPaper, FDSecondaryActionButton, FDStack,
} from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { useSnackbarContext } from 'Context/SnackbarContext';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import { noop } from 'Helpers/PropTypes';

export function GoalSummaryItem({ onEditItem = noop, onDeleteItem = noop }) {
  const [loading, setLoading] = React.useState(false);
  const { resource } = useMetaLayoutContext();
  const { displayErrorMessage } = useSnackbarContext();
  const fields = resource.meta().template().list().filter((field) => field.attr('name') !== 'title');

  const handleDelete = async () => {
    setLoading(true);
    try {
      await onDeleteItem(resource);
    } catch (e) {
      displayErrorMessage(e, e.errors || 'failed to delete goal');
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = async (rel) => {
    try {
      await onEditItem(rel);
    } catch (e) {
      displayErrorMessage(e, e.errors || 'failed to edit goal');
    } finally {
      setLoading(false);
    }
  };

  const EditButton = resource.withRelationship(fr.relationships.edit.name,
    (rel) => <FDSecondaryActionButton loading={loading} size={'sm'} icon={'edit'} label={rel.meta('prompt')} onClick={() => handleEdit(rel)} />,
    () => null);

  return (
    <FDPaper padding={4} width={'100%'}>
      <FDStack direction="column" spacing={2}>
        <FDStack direction="row" alignItems={'center'} spacing={2}>
          <MetaControlField attr={'title'} />
          <FDBox flexGrow={1} />
          {EditButton}
          {resource.meta().canDelete() ? <FDDeleteButton appearance={'secondary'} onClick={handleDelete} loading={loading} /> : null}
        </FDStack>
        <FDStack direction="column" spacing={1} paddingX={2}>
          {fields.map((field) => <MetaControlField key={`${resource.id()}-${field.attr('name')}`} attr={field.attr('name')} simpleRootStyle />)}
        </FDStack>
      </FDStack>
    </FDPaper>
  );
}

GoalSummaryItem.propTypes = {
  onEditItem: PropTypes.func,
  onDeleteItem: PropTypes.func,
};
